import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/airbnb-short-term-rental-loans")({
  component: () => <Outlet />,
});
